import { render } from "./log.vue?vue&type=template&id=f1483e32"
import script from "./log.vue?vue&type=script&lang=js"
export * from "./log.vue?vue&type=script&lang=js"

import "./log.vue?vue&type=style&index=0&id=f1483e32&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__